import { type RxCollection, type RxCollectionCreator } from 'rxdb';
import { AppointmentProposalOption } from '../../../data-access/appointmentProposalOptions';
import {
  identityMigration,
  lwwConflictHandler,
} from '../../rxdb/utils/collectionDefaults';

const optionsSchema = {
  version: 4,
  primaryKey: 'appointmentProposalOptionId',
  type: 'object',
  properties: {
    appointmentProposalOptionId: { type: 'string', maxLength: 36 },
    appointmentProposalId: { type: 'string', maxLength: 36 },
    appointmentId: { type: 'string', maxLength: 36 },
    jobId: { type: 'string', maxLength: 36 },
    entityType: { type: 'string' },
    name: { type: 'string' },
    summary: { type: 'string' },
    summaryTextPlain: { type: 'string' },
    optionType: { type: 'string' },
    certifications: { type: 'array' },
    status: { type: 'string' },
    sortOrder: { type: 'number' },
    optionFinancingDisabled: { type: 'boolean' },
    acceptedDate: { type: 'string' },
    acceptedBy: { type: 'string' },
    acceptedTermsId: { type: 'string' },
    acceptedSignatureFileId: { type: 'string' },
    acceptedTz: { type: 'string' },
    acceptedTaxSetup: { type: 'object' },
    acceptedFinancePlan: { type: 'object' },
    acceptedLeasingPlan: { type: 'object' },
    financingPlanId: { type: 'string' },
    availableFinancingPlanIds: { type: 'array' },
    leasingPlan: { type: 'object' },
    externalIds: { type: 'array' },
    errorDetail: { type: ['object', 'null'] },
    syncedAt: {
      type: 'number',
      multipleOf: 1,
      maximum: 9999999999999,
      minimum: 0,
    },
    updatedAt: { type: 'string' },
    createdAt: { type: 'string' },
    offlineSyncErrors: { type: ['object', 'null'] },
  },
  indexes: [['appointmentProposalId'], ['syncedAt']],
  required: [
    'appointmentProposalOptionId',
    'appointmentProposalId',
    'syncedAt',
  ],
} as const;

export const optionsCollections: Record<
  'appointment_proposal_options',
  RxCollectionCreator
> = {
  appointment_proposal_options: {
    autoMigrate: false,
    schema: optionsSchema,
    conflictHandler: lwwConflictHandler,
    migrationStrategies: {
      1: identityMigration,
      2: identityMigration,
      3: identityMigration,
      4: identityMigration,
    },
  },
};

export type AppointmentProposalOptionDocType = AppointmentProposalOption & {
  syncedAt: number;
};

export type AppointmentProposalOptionsCollections = {
  appointment_proposal_options: RxCollection<AppointmentProposalOptionDocType>;
};
